import { Button, Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import React, { useEffect, useState } from 'react';
import './styles.scss';
import { DeleteIcon, WalletIcon } from 'cokitchen-icons';
import SortInput from 'components/base/sort-input';
import MemberStatus from 'components/base/member-status';
import { apiService } from 'services/base.service';
import { useParams } from 'react-router';
import DeleteGuest from 'components/modals/delete-guest';
import { formatCurrency } from 'utils/functions';
import AddMoreGuestsModal from 'components/modals/add-more-guests';
import useDashboardContext from 'contexts/dashboard.context';
import SearchInput from 'components/base/search-input';
import RefundModal from 'components/modals/refund-modal';
import { EventGuestParamsType, EventGuestType } from 'models/guest.model';

const GuestTable = () => {
  const { id } = useParams();
  const [filter, setFilter] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedGuest, setSelectedGuest] = useState<EventGuestType[]>([]);
  const [showAddMoreGuestsModal, setShowAddMoreGuestsModal] = useState(false);
  const [peopleArray, setPeopleArray] = useState<EventGuestType[]>([]);
  const [filteredPeople, setFilteredPeople] = useState<EventGuestType[]>([]);
  const [value, setValue] = useState('');
  const [showRefundModal, setShowRefundModal] = useState(false);
  const { activeCompany } = useDashboardContext();
  const companyId = activeCompany?.id;

  const getEventGuests = async () => {
    if (!companyId) return;
    const params: EventGuestParamsType = {};
    if (filter === 'Top Spenders') {
      params.spender = 'most';
    } else if (filter === 'Least Spenders') {
      params.spender = 'least';
    } else if (filter === 'Recently Ordered') {
      params.recent_order = 'true';
    }
    setLoading(true);
    try {
      const res = await apiService.get(`guest/${id}`, { params });
      setPeopleArray(res.data.data);
      setFilteredPeople(res.data.data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getEventGuests();
  }, [filter]);

  const ToggleDel = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  const tableHeaders = ['Name', 'Status', 'Phone no', 'Budget', 'Amount Spent', ''];

  const options = [
    {
      name: 'All',
      onClick: () => {
        setFilter('All');
      }
    },
    {
      name: 'Top Spenders',
      onClick: () => {
        setFilter('Top Spenders');
      }
    },
    {
      name: 'Least Spenders',
      onClick: () => {
        setFilter('Least Spenders');
      }
    },
    {
      name: 'Recently Ordered',
      onClick: () => {
        setFilter('Recently Ordered');
      }
    }
  ];

  useEffect(() => {
    const filtered = peopleArray.filter(
      (people) =>
        people.first_name.toLocaleLowerCase().includes(value.toLocaleLowerCase()) ||
        people.last_name.toLocaleLowerCase().includes(value.toLocaleLowerCase())
    );
    setFilteredPeople(filtered);
  }, [value]);

  const handleDelete = (guest: EventGuestType) => {
    setShowDeleteModal(true);
    setSelectedGuest([guest]);
  };

  const removeGuests = (ids: string[]) => {
    setFilteredPeople((prevPeople) => {
      return prevPeople.filter((person) => !ids.includes(person.id));
    });
  };
  const handleRefund = (guest: EventGuestType) => {
    setSelectedGuest([guest]);
    setShowRefundModal(true);
  };

  return (
    <div className='table-auto'>
      <div className='flex flex-col justify-start sm:flex-row sm:justify-between sm:items-center mt-6'>
        <p className='font-[500] my-[20px]'>Guests ({filteredPeople.length ?? 0})</p>
        <div className='flex flex-wrap sm:flex-nowrap gap-2 sm:gap-3 mb-6 items-center guest_header'>
          <SortInput options={options} filterValue={filter} setFilterValue={setFilter} />
          <div className='flex items-center gap-1 w-full sm:w-fit'>
            <div className='w-full max-w-[85vw] sm:sm:max-w-[255px]'>
              <SearchInput value={value} handleChange={(e) => setValue(e.target.value)} />
            </div>
          </div>
        </div>
      </div>

      {filteredPeople.length === 0 ? (
        <div className='flex justify-center items-center h-[30vh] flex-col gap-4'>
          <p>There are no guests for this event</p>
          <Button
            variant='block'
            color='primary'
            small
            className='w-fit'
            onClick={() => setShowAddMoreGuestsModal(true)}>
            Add Guests
          </Button>
        </div>
      ) : (
        <Table loading={loading} headers={tableHeaders}>
          {filteredPeople?.map((guest) => (
            <TableRow key={guest?.id} className='hover:bg-[#F5F6F6] table_row'>
              <TableData>
                <p className='capitalize'>
                  {guest?.first_name} {guest?.last_name}
                </p>
              </TableData>
              <TableData>
                <MemberStatus status={guest?.active ? 'Joined' : 'Pending'} />
              </TableData>
              <TableData>{guest?.phone_number}</TableData>
              <TableData>
                {formatCurrency(guest?.budget, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })}
              </TableData>
              <TableData>{formatCurrency(guest?.spent)}</TableData>

              <TableData>
                <div className={`flex gap-2 w-[74px]`}>
                  <WalletIcon onClick={() => handleRefund(guest)} className='w-5 h-5 icon' />

                  <DeleteIcon
                    onClick={() => handleDelete(guest)}
                    className='w-5 h-5 text-[#E60A2B] icon'
                  />
                </div>
              </TableData>
            </TableRow>
          ))}
        </Table>
      )}
      <DeleteGuest
        onClose={ToggleDel}
        show={showDeleteModal}
        selectedGuest={selectedGuest}
        setSelectedGuest={setSelectedGuest}
        removeGuests={removeGuests}
      />
      <AddMoreGuestsModal
        isOpen={showAddMoreGuestsModal}
        onClose={() => setShowAddMoreGuestsModal(false)}
      />
      <RefundModal
        guests={selectedGuest}
        show={showRefundModal}
        onClose={() => setShowRefundModal(false)}
      />
    </div>
  );
};

export default GuestTable;
